import axios from 'axios';
import { OktaAuth } from '@okta/okta-auth-js';
import FileSaver from 'file-saver';
import { oktaAuthConfig } from '../store.constant';
import { storeAction } from '../storeActions.constant';
import { storeGetters } from '../storeGetters.constant';
import { storeMutation } from '../storeMutations.constant';
import { getAxiosCancelTokenSource } from "../../app.utils";
import {
    getBasicHeaders,
    fetchAndCacheData,
    getHeadersWithFormData,
    imageWithTimeStamp,
} from '../../common/utils/utils';
import { wrapAction } from '../../common/utils/actionLifecycle';
import { memberProfileWizards } from '../../components/MemberProfile/memberProfile.constants';
import { routerNames } from "../../components/appCommon.constants";
import { appConstant } from "@/app.constant";

const memberProfileState = {
    baseURL: process.env.VUE_APP_BASE_URL,
    ypoAwardsInformation: '',
    biographyInformation: '',
    companyInvestments: '',
    championPositions: '',
    familyInterests: [],
    familyDetails: '',
    professionalRoles: '',
    accomplishments: '',
    trainingAndCertifications: '',
    isAboutMeVisible: true,
    isYpoCommunitiesVisible: true,
    isProfessionalExperienceVisible: true,
    educationDetails: '',
    contactInformation: '',
    networkChapters: '',
    networkRegions: '',
    networks: '',
    events: '',
    currentUserId: '',
    vCardDetails: '',
    professionalExperience: [],
    userProfile: '',
    isFormerMember: false,
    profileConnection: '',
    myActivity: null,
    profileFollowing: '',
    editEducationResponse: '',
    saveEducationResponse: '',
    schoolTypes: [],
    degreeTypes: [],
    educationSearchResult: '',
    industory: '',
    externalConnectionIndustry: '',
    courseAndCertificateSearchResult: '',
    presidentTypes: [],
    companyTypes: [],
    companySizes: [],
    businessScopes: [],
    countryAndStates: [],
    familyInterestTypes: [],
    editProfessionalExperienceResponse: null,
    saveProfessionalExperienceResponse: null,
    deleteProfessionalExperienceResponse: null,
    professionalExperienceSearchResults: [],
    businessInterestTypes: [],
    relationshipStatusTypes: [],
    updatePersonExternalResponse: '',
    savePersonExternalResponse: '',
    deletePersonExternalResponse: '',
    allPrefixes: [],
    allSuffixes: [],
    isRelationshipStatus: false,
    wizards: memberProfileWizards(),
    spousePartnerAccessTypes: [],
    emergencyContactRelationTypes: [],
    addressTypes: [],
    socialNetworkTypes: [],
    recommendedEvents: {},
    recommendedEventsURL: `${process.env.VUE_APP_BASE_URL}profiles/api/member-profile/get-recommended-events`,
    recommendedMembers: [],
    reasonsToConnect: {},
    communitiesGroup: [],
    communities:[],
    isFamilyInterestsLoading: false,
    chapterAdmin: false,
    assetSummaryShortcut: null,
    assetSummary: [],
    countryAndRegions: [],
    searchProfile: [],
    pendingAssets: [],
    streetAddress: '',
    profileDropDowns: [],
    userProfileImageExists: false,
    canUserImpersonate: false,
};

const authClient = new OktaAuth(oktaAuthConfig);

const memberProfileMutations = {
    [storeMutation.setReasonsToConnect]: (state, data) => {
        state.reasonsToConnect = data;
    },
    [storeMutation.setCurrentUserId]: (state, data) => {
        let userId = data ? data.toLowerCase() : '';
        const impersonationKey = sessionStorage.getItem(appConstant.storageKeys.impersonationKey);
        userId = impersonationKey || userId;
        state.currentUserId = userId;
    },
    [storeMutation.setUserProfile]: (state, data) => {
        state.userProfile = data;
        state.canUserImpersonate = data.canImpersonate;
    },
    [storeMutation.setImpersonationRole]: (state, data) => {
        state.canUserImpersonate = data || false;
    },
    [storeMutation.setUpdatedUserProfile]: (state, data) => {
        if (state.userProfile !== '' && data && state.userProfile.id === data.id) {
            state.userProfile.firstName = data.firstName;
            state.userProfile.middleName = data.middleName;
            state.userProfile.lastName = data.lastName;
            state.userProfile.preferredName = data.preferredName;
            state.userProfile.prefix = data.prefix;
            state.userProfile.salutation = data.salutation;
            state.userProfile.suffix = data.suffix;
        }
    },
    [storeMutation.setYPOAwards]: (state, data) => {
        state.ypoAwardsInformation = data;
    },
    [storeMutation.setBiography]: (state, data) => {
        state.biographyInformation = data;
    },
    [storeMutation.setCompanyInvestments]: (state, data) => {
        state.companyInvestments = data;
    },
    [storeMutation.setChampionPositions]: (state, data) => {
        state.championPositions = data;
    },
    [storeMutation.setFamilyInterests]: (state, data) => {
        state.familyInterests = data;
    },
    [storeMutation.setFamilyDetails]: (state, data) => {
        state.familyDetails = data;
    },
    [storeMutation.setProfessionalRoles]: (state, data) => {
        state.professionalRoles = data;
    },
    [storeMutation.setAccomplishments]: (state, data) => {
        state.accomplishments = data;
    },
    [storeMutation.setTrainingAndCertifications]: (state, data) => {
        state.trainingAndCertifications = data;
    },
    [storeMutation.setEducationDetails]: (state, data) => {
        state.educationDetails = data;
    },
    [storeMutation.setContactInformation]: (state, data) => {
        state.contactInformation = data;
    },
    [storeMutation.setNetworkChapters]: (state, data) => {
        state.networkChapters = data;
    },
    [storeMutation.setNetworkRegions]: (state, data) => {
        state.networkRegions = data;
    },
    [storeMutation.setNetworks]: (state, data) => {
        state.networks = data;
    },
    [storeMutation.setCommunities]: (state, data) => {
        state.communities = data;
    },
    [storeMutation.setEvents]: (state, data) => {
        state.events = data;
    },
    [storeMutation.setVcardDetails]: (state, data) => {
        state.vCardDetails = data;
    },
    [storeMutation.setProfessionalExperience]: (state, data) => {
        state.professionalExperience = data;
    },
    [storeMutation.setProfileConnection]: (state, data) => {
        state.profileConnection = data;
    },
    [storeMutation.setProfileFollowing]: (state, data) => {
        state.profileFollowing = data;
    },
    [storeMutation.setMyActivity]: (state, data) => {
        state.myActivity = data;
    },
    [storeMutation.setUpdatePersonExternalConnections]: (state, data) => {
        state.updatePersonExternalResponse = data;
    },
    [storeMutation.setSavePersonExternalConnections]: (state, data) => {
        state.savePersonExternalResponse = data;
    },
    [storeMutation.setEducationSearchResult]: (state, data) => {
        state.educationSearchResult = data;
    },
    [storeMutation.setCourseAndCertificateSearchResult]: (state, data) => {
        state.courseAndCertificateSearchResult = data;
    },
    [storeMutation.setEditProfessionalExperienceResponse]: (state, data) => {
        state.editProfessionalExperienceResponse = data;
    },
    [storeMutation.setSaveProfessionalExperienceResponse]: (state, data) => {
        state.saveProfessionalExperienceResponse = data;
    },
    [storeMutation.setBusinessInterestTypes]: (state, data) => {
        state.businessInterestTypes = data;
    },
    [storeMutation.setProfilePhoto]: (state, data) => {
        state.profilePhoto = data;
        state.userProfile = {
            ...state.userProfile,
            profileImageUrl: data,
        };
    },
    [storeMutation.setProfessionalExperienceSearchResults]: (state, data) => {
        state.professionalExperienceSearchResults = data;
    },
    [storeMutation.setRecommendedEvents]: (state, data) => {
        state.recommendedEvents = data || [];
    },
    [storeMutation.updateRecommendedEventsCache]: (state, data) => {
        data = data || [];
        caches.open('MyRecommendedEvents').then((cache) => {
            return cache.match(state.recommendedEventsURL).then(async (response) => {
                const responseJSON = await response.json();
                cache.put(
                    state.recommendedEventsURL,
                    new Response(JSON.stringify({ requestedTime: responseJSON.requestedTime, data })),
                );
            });
        });
        state.recommendedEvents = data;
    },
    [storeMutation.setRecommendedMembers]: (state, data) => {
        state.recommendedMembers = data;
    },
    [storeMutation.setCommunitiesGroup]: (state, data) => {
        state.communitiesGroup = data;
    },
    [storeMutation.setIsFamilyInterestsLoading]: (state, data) => {
        state.isFamilyInterestsLoading = data;
    },
    [storeMutation.setChapterAdmin]: (state, data) => {
        state.chapterAdmin = data;
    },
    [storeMutation.setAssetSummaryShortcut]: (state, data) => {
        state.assetSummaryShortcut = data;
    },
    [storeMutation.setAssetSummary]: (state, data) => {
        state.assetSummary = data;
    },
    [storeMutation.setCountryAndRegions]: (state, data) => {
        state.countryAndRegions = data;
    },
    [storeMutation.setSearchProfile]: (state, data) => {
        state.searchProfile = data;
    },
    [storeMutation.setPendingAssets]: (state, data) => {
        state.pendingAssets = data;
    },
    [storeMutation.setStreetAddress]: (state, data) => {
        state.streetAddress = data;
    },
    [storeMutation.setProfileDropDowns]: (state, data) => {
        state.profileDropDowns = data;
        state.industory = data.industry;
        state.presidentTypes = data.presidentType;
        state.companyTypes = data.companyType;
        state.companySizes = data.companySize;
        state.businessScopes = data.businessScopeType;
        state.countryAndStates = data.countryAndStateProvince;
        state.externalConnectionIndustry = data.externalConnectionIndustry;
        state.familyInterestTypes = data.familyInterestType;
        state.relationshipStatusTypes = data.relationshipStatusType;
        state.addressTypes = data.addressType;
        state.emergencyContactRelationTypes = data.emergencyRelationshipToMemberType;
        state.schoolTypes = data.schoolType;
        state.degreeTypes = data.degreeType;
        state.allPrefixes = data.prefix;
        state.allSuffixes = data.suffix;
        state.spousePartnerAccessTypes = data.spousePartnerAccessType;
        state.socialNetworkTypes = data.socialNetworkType;
    },
    [storeMutation.setUserProfileImageExists]: (state, data) => {
        state.userProfileImageExists = data;
    },
};

const memberProfileActions = {
    [storeAction.getAccessToken]: () => {
        return authClient.tokenManager.get('accessToken').then((token) => {
            return token && token.accessToken;
        });
    },
    [storeAction.getAccessTokenDecoded]: () => {
        return authClient.tokenManager.get('accessToken').then((token) => {
            return token && authClient.token.decode(token.accessToken);
        });
    },
    [storeAction.getCurrentUserId]: ({ commit, rootGetters }) => {
        return new Promise((resolve) => {
            const authData = rootGetters[`auth/${storeGetters.authData}`];
            const { authProvider, userGuid } = authData;
            if (authProvider && authProvider.toLowerCase() === "salesforce") {
                commit(storeMutation.setCurrentUserId, userGuid);
                resolve();
            } else {
                authClient.tokenManager.get('accessToken').then((token) => {
                    if (token) {
                        const accessTokenData = token.accessToken && authClient.token.decode(token.accessToken);
                        if (accessTokenData && accessTokenData.payload.ypoId) {
                            commit(storeMutation.setCurrentUserId, accessTokenData.payload.ypoId);
                            resolve();
                        }
                    }
                });
            }
        });
    },
    [storeAction.getUserProfile]: wrapAction(storeAction.getUserProfile, ({ state, commit }, personId) => {
        return axios({
            url: `${state.baseURL}profiles/api/v2/member-profile/get-profile-summary/${personId}`,
            headers: getBasicHeaders(),
            method: 'GET',
        })
            .then((response) => {
                commit(storeMutation.setUserProfile, response.data);
                return response;
            })
            .catch((err) => {
                commit(storeMutation.setUserProfile, '');
                console.log(err);
                throw err;
            });
    }),
    [storeAction.getUserProfileWithoutWrapper]: ({ state, commit }, personId) => {
        return axios({
            url: `${state.baseURL}profiles/api/v2/member-profile/get-profile-summary/${personId}`,
            headers: getBasicHeaders(),
            method: 'GET',
        })
            .then((res) => {
                commit(storeMutation.setUserProfile, res.data);
                return res;
            })
            .catch((err) => {
                throw err;
            });
    },
    [storeAction.getUserCommunity]: wrapAction(storeAction.getUserCommunity, ({ state, commit }, personId) => {
        return axios({
            url: `${state.baseURL}profiles/api/usercommunity/${personId}`,
            headers: getBasicHeaders(),
            method: 'GET',
        })
            .then((response) => {
                commit(storeMutation.setUserCommunity, response.data.communityName);
                return response.data.communityName;
            })
            .catch((err) => {
                console.log(err);
                throw err;
            });
    }),
    [storeAction.getYPOAwards]: wrapAction(storeAction.getYPOAwards, ({ state, commit }, personId) => {
        return axios({
            url: `${state.baseURL}profiles/api/v2/member-profile/get-awards/${personId}`,
            headers: getBasicHeaders(),
            method: 'GET',
        })
            .then((response) => {
                commit(storeMutation.setYPOAwards, response.data);
                return response;
            })
            .catch((err) => {
                console.log(err);
                throw err;
            });
    }),
    [storeAction.getBiography]: ({ state, commit }, personId) => {
        return axios({
            url: `${state.baseURL}profiles/api/member-profile/get-biography/${personId}`,
            headers: getBasicHeaders(),
            method: 'GET',
        })
            .then((response) => {
                commit(storeMutation.setBiography, response.data);
                return response;
            })
            .catch((err) => {
                console.log(err);
                throw err;
            });
    },
    [storeAction.getCompanyInvestments]: wrapAction(
        storeAction.getCompanyInvestments,
        ({ state, commit }, personId) => {
            return axios({
                url: `${state.baseURL}profiles/api/v2/member-profile/get-company-investments/${personId}`,
                headers: getBasicHeaders(),
                method: 'GET',
            })
                .then((response) => {
                    commit(storeMutation.setCompanyInvestments, response.data);
                    return response;
                })
                .catch((err) => {
                    console.log(err);
                    throw err;
                });
        },
    ),
    [storeAction.getChampionPositions]: wrapAction(storeAction.getChampionPositions, ({ state, commit }, personId) => {
        return axios({
            url: `${state.baseURL}profiles/api/v2/member-profile/get-ypo-champion-positions/${personId}`,
            headers: getBasicHeaders(),
            method: 'GET',
        })
            .then((response) => {
                commit(storeMutation.setChampionPositions, response.data);
                return response;
            })
            .catch((err) => {
                console.log(err);
                throw err;
            });
    }),
    [storeAction.getFamilyDetails]: wrapAction(storeAction.getFamilyDetails, ({ state, commit }, personId) => {
        return axios({
            url: `${state.baseURL}profiles/api/v2/member-profile/get-relationships/${personId}`,
            headers: getBasicHeaders(),
            method: 'GET',
        })
            .then((response) => {
                commit(storeMutation.setFamilyDetails, response.data);
                return response;
            })
            .catch((err) => {
                console.log(err);
                throw err;
            });
    }),
    [storeAction.getFamilyInterests]: wrapAction(storeAction.getFamilyInterests, ({ state, commit }, personId) => {
        commit(storeMutation.setIsFamilyInterestsLoading, true);
        return axios({
            url: `${state.baseURL}profiles/api/member-profile/get-interests/${personId}`,
            headers: getBasicHeaders(),
            method: 'GET',
        })
            .then((response) => {
                commit(storeMutation.setFamilyInterests, response.data);
                commit(storeMutation.setIsFamilyInterestsLoading, false);
                return response;
            })
            .catch((err) => {
                console.log(err);
                commit(storeMutation.setIsFamilyInterestsLoading, false);
                throw err;
            });
    }),
    [storeAction.getAccomplishments]: wrapAction(storeAction.getAccomplishments, ({ state, commit }, personId) => {
        return axios({
            url: `${state.baseURL}profiles/api/member-profile/get-accomplishments/${personId}`,
            headers: getBasicHeaders(),
            method: 'GET',
        })
            .then((response) => {
                commit(storeMutation.setAccomplishments, response.data);
                return response;
            })
            .catch((err) => {
                console.log(err);
                throw err;
            });
    }),
    [storeAction.getProfessionalRoles]: wrapAction(storeAction.getProfessionalRoles, ({ state, commit }, personId) => {
        return axios({
            url: `${state.baseURL}profiles/api/member-profile/get-professional-roles/${personId}`,
            headers: getBasicHeaders(),
            method: 'GET',
        })
            .then((response) => {
                commit(storeMutation.setProfessionalRoles, response.data);
                return response;
            })
            .catch((err) => {
                console.log(err);
                throw err;
            });
    }),
    [storeAction.getTrainingAndCertifications]: wrapAction(storeAction.getTrainingAndCertifications, ({ state, commit }, personId) => {
        return axios({
            url: `${state.baseURL}profiles/api/member-profile/get-training-and-certificates/${personId}`,
            headers: getBasicHeaders(),
            method: 'GET',
        })
            .then((response) => {
                commit(storeMutation.setTrainingAndCertifications, response.data);
                return response;
            })
            .catch((err) => {
                console.log(err);
                throw err;
            });
    }),
    [storeAction.getEducationDetails]: wrapAction(storeAction.getEducationDetails, ({ state, commit }, personId) => {
        return axios({
            url: `${state.baseURL}profiles/api/member-profile/get-education-details/${personId}`,
            headers: getBasicHeaders(),
            method: 'GET',
        })
            .then((response) => {
                commit(storeMutation.setEducationDetails, response.data);
                return response;
            })
            .catch((err) => {
                console.log(err);
                throw err;
            });
    }),
    [storeAction.getContactInformation]: wrapAction(storeAction.getContactInformation, ({ state, commit }, personId) => {
        return axios({
            url: `${state.baseURL}profiles/api/member-profile/get-contact-details/${personId}`,
            headers: getBasicHeaders(),
            method: 'GET',
        })
            .then((response) => {
                commit(storeMutation.setContactInformation, response.data);
                return response;
            })
            .catch((err) => {
                console.log(err);
                throw err;
            });
    }),
    [storeAction.getNetworkChapters]: ({ state, commit }, personId) => {
        return axios({
            url: `${state.baseURL}profiles/api/member-profile/get-chapters/${personId}`,
            headers: getBasicHeaders(),
            method: 'GET',
        })
            .then((response) => {
                commit(storeMutation.setNetworkChapters, response.data);
                return response;
            })
            .catch((err) => {
                console.log(err);
                throw err;
            });
    },
    [storeAction.getNetworkRegions]: ({ state, commit }, personId) => {
        return axios({
            url: `${state.baseURL}profiles/api/member-profile/get-regions/${personId}`,
            headers: getBasicHeaders(),
            method: 'GET',
        })
            .then((response) => {
                commit(storeMutation.setNetworkRegions, response.data);
                return response;
            })
            .catch((err) => {
                console.log(err);
                throw err;
            });
    },
    [storeAction.getNetworks]: wrapAction(storeAction.getNetworks, ({ state, commit }, personId) => {
        return axios({
            url: `${state.baseURL}profiles/api/member-profile/get-networks/${personId}`,
            headers: getBasicHeaders(),
            method: 'GET',
        })
            .then((response) => {
                commit(storeMutation.setNetworks, response.data);
                return response;
            })
            .catch((err) => {
                console.log(err);
                throw err;
            });
    }),

    [storeAction.getCommunities]: wrapAction(storeAction.getCommunities, ({ state, commit }, personId) => {
        return axios({
            url: `${state.baseURL}profiles/api/member-profile/get-communities-recordtypename-community/${personId}`,
            headers: getBasicHeaders(),
            method: 'GET',
        })
            .then((response) => {
                commit(storeMutation.setCommunities, response.data);
                return response;
            })
            .catch((err) => {
                console.log(err);
                throw err;
            });
    }),

    [storeAction.getEvents]: wrapAction(storeAction.getEvents, ({ state, commit }, personId) => {
        return axios({
            url: `${state.baseURL}profiles/api/member-profile/get-upcoming-events/${personId}`,
            headers: getBasicHeaders(),
            method: 'GET',
        })
            .then((response) => {
                commit(storeMutation.setEvents, response.data);
                return response;
            })
            .catch((err) => {
                console.log(err);
                throw err;
            });
    }),
    [storeAction.getVCardDetails]: ({ state, commit }, personId) => {
        return axios({
            url: `${state.baseURL}profiles/api/member-profile/get-vcard/${personId}`,
            headers: getBasicHeaders(),
            method: 'GET',
        })
            .then((response) => {
                commit(storeMutation.setVcardDetails, response.data);
                return response;
            })
            .catch((err) => {
                console.log(err);
                throw err;
            });
    },
    [storeAction.getProfessionalExperience]: wrapAction(
        storeAction.getProfessionalExperience,
        ({ state, commit }, personId) => {
            return axios({
                url: `${state.baseURL}profiles/api/member-profile/get-professional-experience/${personId}`,
                headers: getBasicHeaders(),
                method: 'GET',
            })
                .then((response) => {
                    commit(storeMutation.setProfessionalExperience, response.data);
                    return response;
                })
                .catch((err) => {
                    console.log(err);
                    throw err;
                });
        },
    ),
    [storeAction.getProfileConnection]: ({ state, commit }, personId) => {
        return axios({
            url: `${state.baseURL}profiles/api/member-profile/get-memberprofile-connection/${personId}`,
            headers: getBasicHeaders(),
            method: 'GET',
        })
            .then((response) => {
                commit(storeMutation.setProfileConnection, response.data);
                return response;
            })
            .catch((err) => {
                console.log(err);
                throw err;
            });
    },
    [storeAction.addConnection]: ({ state }, requestBody) => {
        return axios({
            url: `${state.baseURL}profiles/api/member-profile/save-memberprofile-connection`,
            headers: getBasicHeaders(),
            data: requestBody,
            method: 'POST',
        })
            .then((response) => {
                return response;
            })
            .catch((err) => {
                console.log(err);
                throw err.response.data;
            });
    },
    [storeAction.getProfileFollowing]: ({ state, commit }, personId) => {
        return axios({
            url: `${state.baseURL}profiles/api/member-profile/get-memberprofile-connection/${personId}`,
            headers: getBasicHeaders(),
            method: 'GET',
        })
            .then((response) => {
                commit(storeMutation.setProfileFollowing, response.data);
                return response;
            })
            .catch((err) => {
                console.log(err);
                throw err;
            });
    },
    [storeAction.addBulkConnections]: ({ state }, requestBody) => {
        return axios({
            url: `${state.baseURL}profiles/api/member-profile/save-memberprofile-connections`,
            headers: getBasicHeaders(),
            data: requestBody,
            method: 'POST',
        })
            .then((response) => {
                return response;
            })
            .catch((err) => {
                console.log(err);
                throw err.response.data;
            });
    },
    [storeAction.getMyActivity]: ({ state, commit }, personId) => {
        return axios({
            // url: `${state.baseURL}profiles/api/member-profile/get-myactivity/${personId}`,
            url: `/mocks/myActivity.json`,
            headers: getBasicHeaders(),
            method: 'GET',
        })
            .then((response) => {
                commit(storeMutation.setMyActivity, response.data);
                return response;
            })
            .catch((err) => {
                console.log(`${state.baseURL}profiles/api/member-profile/get-myactivity/${personId}`);
                throw err;
            });
    },
    [storeAction.searchExternalConnection]: ({ state, commit }, postBody) => {
        return axios({
            url: `${state.baseURL}profiles/api/member-profile/search-external-connection-name`,
            headers: getBasicHeaders(),
            data: postBody,
            method: 'POST',
        })
            .then((response) => {
                commit(storeMutation.setCourseAndCertificateSearchResult, response.data);
                return response;
            })
            .catch((err) => {
                console.log(err);
                throw err.response.data;
            });
    },
    [storeAction.editEducation]: wrapAction(storeAction.editEducation, ({ state, commit }, requestBody) => {
        return axios({
            url: `${state.baseURL}profiles/api/v2/member-profile/edit-education-details`,
            headers: getBasicHeaders(),
            data: requestBody,
            method: 'PUT',
        })
            .then((response) => {
                commit(storeMutation.setEducationDetails, response.data);
                return response;
            })
            .catch((err) => {
                console.log(err);
                throw err;
            });
    }),
    [storeAction.saveEducation]: wrapAction(storeAction.saveEducation, ({ state, commit }, requestBody) => {
        return axios({
            url: `${state.baseURL}profiles/api/v2/member-profile/save-education-details`,
            headers: getBasicHeaders(),
            data: requestBody,
            method: 'POST',
        })
            .then((response) => {
                commit(storeMutation.setEducationDetails, response.data);
                return response;
            })
            .catch((err) => {
                console.log(err);
                throw err;
            });
    }),
    [storeAction.deleteEducation]: wrapAction(storeAction.deleteEducation, ({ state, commit }, parms) => {
        return axios({
            url: `${state.baseURL}profiles/api/v2/member-profile/delete-education/${parms.educationId}`,
            headers: getBasicHeaders(),
            method: 'PUT',
            data: parms,
        })
            .then((response) => {
                commit(storeMutation.setEducationDetails, response.data);
                return response;
            })
            .catch((err) => {
                console.log(err);
                throw err;
            });
    }),
    [storeAction.searchEducation]: ({ state, commit }, searchData) => {
        return axios({
            url: `${state.baseURL}profiles/api/member-profile/search-school-by-name`,
            headers: getBasicHeaders(),
            method: 'POST',
            data: searchData,
        })
            .then((response) => {
                commit(storeMutation.setEducationSearchResult, response.data);
                return response;
            })
            .catch((err) => {
                console.log(err);
                throw err;
            });
    },
    [storeAction.saveRelationshipStatus]: ({ state }, requestBody) => {
        return axios({
            url: `${state.baseURL}profiles/api/v2/member-profile/save-relationship-status`,
            headers: getBasicHeaders(),
            data: requestBody,
            method: 'PUT',
        })
            .then((response) => {
                return response;
            })
            .catch((err) => {
                console.log(err);
                throw err;
            });
    },
    [storeAction.editProfessionalExperience]: wrapAction(
        storeAction.editProfessionalExperience,
        ({ state, commit }, requestBody) => {
            return axios({
                url: `${state.baseURL}profiles/api/v2/member-profile/update-professional-experience`,
                headers: getBasicHeaders(),
                data: requestBody,
                method: 'PUT',
            })
                .then((response) => {
                    commit(storeMutation.setProfessionalExperience, response.data);
                    return response;
                })
                .catch((err) => {
                    console.log(err);
                    throw err;
                });
        },
    ),
    [storeAction.saveProfessionalExperience]: wrapAction(
        storeAction.saveProfessionalExperience,
        ({ state, commit }, requestBody) => {
            return axios({
                url: `${state.baseURL}profiles/api/v2/member-profile/save-professional-experience`,
                headers: getBasicHeaders(),
                data: requestBody,
                method: 'POST',
            })
                .then((response) => {
                    commit(storeMutation.setProfessionalExperience, response.data);
                    return response;
                })
                .catch((err) => {
                    console.log(err);
                    throw err;
                });
        },
    ),
    [storeAction.deleteProfessionalExperience]: wrapAction(
        storeAction.deleteProfessionalExperience,
        ({ state, commit }, parms) => {
            return axios({
                url: `${state.baseURL}profiles/api/v2/member-profile/delete-person-professional-experience/${parms.primaryId}`,
                headers: getBasicHeaders(),
                method: 'PUT',
                data: parms,
            })
                .then((response) => {
                    commit(storeMutation.setProfessionalExperience, response.data);
                    return response;
                })
                .catch((err) => {
                    console.log(err);
                    throw err;
                });
        },
    ),
    [storeAction.searchProfessionalExperience]: ({ state, commit }, companyName) => {
        return axios({
            url: `${state.baseURL}profiles/api/member-profile/search-company-by-name`,
            headers: getBasicHeaders(),
            method: 'POST',
            data: {
                name: companyName,
                type: 'Business',
            },
        })
            .then((response) => {
                commit(storeMutation.setProfessionalExperienceSearchResults, response.data);
                return response;
            })
            .catch((err) => {
                console.log(err);
                throw err;
            });
    },
    [storeAction.updatePersonExternalConnection]: wrapAction(
        storeAction.updatePersonExternalConnection,
        ({ state }, requestBody) => {
            return axios({
                url: `${state.baseURL}profiles/api/member-profile/update-person-external-connection`,
                headers: getBasicHeaders(),
                data: requestBody,
                method: 'PUT',
            })
                .then((response) => {
                    return response;
                })
                .catch((err) => {
                    console.log(err);
                    throw err;
                });
        },
    ),
    [storeAction.savePersonExternalConnection]: wrapAction(
        storeAction.savePersonExternalConnection,
        ({ state }, requestBody) => {
            return axios({
                url: `${state.baseURL}profiles/api/member-profile/save-person-external-connection`,
                headers: getBasicHeaders(),
                data: requestBody,
                method: 'POST',
            })
                .then((response) => {
                    return response;
                })
                .catch((err) => {
                    console.log(err);
                    throw err;
                });
        },
    ),
    [storeAction.saveBiography]: wrapAction(storeAction.saveBiography, ({ state }, requestBody) => {
        return axios({
            url: `${state.baseURL}profiles/api/member-profile/save-biography`,
            headers: getBasicHeaders(),
            data: requestBody,
            method: 'PUT',
        })
            .then((response) => {
                return response;
            })
            .catch((err) => {
                console.log(err);
                throw err();
            });
    }),
    [storeAction.deletePersonExternalConnection]: wrapAction(
        storeAction.deletePersonExternalConnection,
        ({ state }, parms) => {
            return axios({
                url: `${state.baseURL}profiles/api/member-profile/delete-person-external-connection/${parms.companyId}`,
                headers: getBasicHeaders(),
                method: 'PUT',
                data: parms,
            })
                .then((response) => {
                    return response;
                })
                .catch((err) => {
                    console.log(err);
                    throw err;
                });
        },
    ),
    [storeAction.getBusinessInterests]: wrapAction(storeAction.getBusinessInterests, ({ state, commit }) => {
        return axios({
            url: `${state.baseURL}profiles/api/member-profile/get-business_interest-types`,
            headers: getBasicHeaders(),
            method: 'GET',
        })
            .then((response) => {
                commit(storeMutation.setBusinessInterestTypes, response.data);
                return response;
            })
            .catch((err) => {
                console.log(err);
                throw err;
            });
    }),
    [storeAction.savePersonInterests]: wrapAction(storeAction.savePersonInterests, ({ state, commit }, requestBody) => {
        return axios({
            url: `${state.baseURL}profiles/api/v2/member-profile/save-person-interests`,
            headers: getBasicHeaders(),
            data: requestBody,
            method: 'POST',
        })
            .then((response) => {
                commit(storeMutation.setFamilyInterests, response.data);
                return response;
            })
            .catch((err) => {
                console.log(err);
                throw err;
            });
    }),
    [storeAction.saveProfileSummaryDetails]: wrapAction(storeAction.saveProfileSummaryDetails, ({ commit, state }, requestBody) => {
        return axios({
            url: `${state.baseURL}profiles/api/v2/member-profile/update-profile-summary`,
            headers: getBasicHeaders(),
            data: requestBody,
            method: 'PUT',
        })
            .then((response) => {
                commit(storeMutation.setUpdatedUserProfile, response.data);
                return response;
            })
            .catch((err) => {
                console.log(err);
                throw err;
            });
    }),
    [storeAction.updateRelationship]: wrapAction(storeAction.updateRelationship, ({ state, commit }, requestBody) => {
        return axios({
            url: `${state.baseURL}profiles/api/v2/member-profile/update-relationship`,
            headers: getBasicHeaders(),
            data: requestBody,
            method: 'PUT',
        })
            .then((response) => {
                commit(storeMutation.setFamilyDetails, response.data);
            })
            .catch((err) => {
                if (err.response.data.message.includes('Email already exists')) {
                    return err.response;
                }
                console.log(err);
                throw err;
            });
    }),
    [storeAction.saveRelationships]: wrapAction(storeAction.saveRelationships, ({ state, commit }, requestBody) => {
        return axios({
            url: `${state.baseURL}profiles/api/v2/member-profile/save-relationships`,
            headers: getBasicHeaders(),
            data: requestBody,
            method: 'POST',
        })
            .then((response) => {
                commit(storeMutation.setFamilyDetails, response.data);
            })
            .catch((err) => {
                if (err.response.data.message.includes('Email already exists')) {
                    return err.response;
                }
                console.log(err);
                throw err;
            });
    }),
    [storeAction.deleteRelationship]: wrapAction(storeAction.deleteRelationship, ({ state, commit }, parms) => {
        return axios({
            url: `${state.baseURL}profiles/api/v2/member-profile/delete-relationship/${parms.relationshipId}`,
            headers: getBasicHeaders(),
            method: 'PUT',
            data: parms,
        })
            .then((response) => {
                commit(storeMutation.setFamilyDetails, response.data);
            })
            .catch((err) => {
                console.log(err);
                throw err;
            });
    }),
    [storeAction.saveEmailInformation]: wrapAction(storeAction.saveEmailInformation, ({ commit, state }, requestBody) => {
        return axios({
            url: `${state.baseURL}profiles/api/v2/member-profile/save-email-address`,
            headers: getBasicHeaders(),
            data: requestBody,
            method: 'PUT',
        })
            .then((response) => {
                commit(storeMutation.setContactInformation, response.data);
                commit(`manageLoginSecurity/${storeMutation.setUserInfo}`, response.data, { root: true });
                return response;
            })
            .catch((err) => {
                if (err.response && err.response.data && err.response.data.message.includes('Email already exists')) {
                    return err.response;
                }
                console.log(err);
                throw err;
            });
    }),
    [storeAction.savePhoneInformation]: wrapAction(storeAction.savePhoneInformation, ({ commit, state }, requestBody) => {
        return axios({
            url: `${state.baseURL}profiles/api/v2/member-profile/save-phone-number-details`,
            headers: getBasicHeaders(),
            data: requestBody,
            method: 'PUT',
        })
            .then((response) => {
                commit(storeMutation.setContactInformation, response.data);
                return response;
            })
            .catch((err) => {
                console.log(err);
                throw err;
            });
    }),
    [storeAction.saveEmergencyContact]: wrapAction(storeAction.saveEmergencyContact, ({ state, commit }, requestBody) => {
        return axios({
            url: `${state.baseURL}profiles/api/v2/member-profile/save-emergency-contact-details`,
            headers: getBasicHeaders(),
            data: requestBody,
            method: 'PUT',
        })
            .then((response) => {
                commit(storeMutation.setContactInformation, response.data);
                return response;
            })
            .catch((err) => {
                console.log(err);
                throw err;
            });
    }),
    [storeAction.uploadProfilePhoto]: wrapAction(storeAction.uploadProfilePhoto, ({ state, commit }, requestBody) => {
        return axios({
            url: `${state.baseURL}profiles/api/member-profile/upload-profile-photo`,
            headers: getBasicHeaders(),
            method: 'POST',
            data: requestBody,
        })
            .then((response) => {
                const updatedImageWithTimeStamp = imageWithTimeStamp(response.data);
                commit(storeMutation.setProfilePhoto, updatedImageWithTimeStamp);
                commit(`myAccount/${storeMutation.updateProfileImageUrl}`, updatedImageWithTimeStamp, { root: true });
                return updatedImageWithTimeStamp;
            })
            .catch((err) => {
                console.log(err);
                throw err;
            });
    }),
    [storeAction.saveAddress]: wrapAction(storeAction.saveAddress, ({ state, commit }, requestBody) => {
        return axios({
            url: `${state.baseURL}profiles/api/v2/member-profile/save-address-details`,
            headers: getBasicHeaders(),
            data: requestBody,
            method: 'PUT',
        })
            .then((response) => {
                commit(storeMutation.setContactInformation, response.data);
                return response;
            })
            .catch((err) => {
                console.log(err);
                throw err;
            });
    }),
    [storeAction.updateSocialNetworkDetails]: wrapAction(
        storeAction.updateSocialNetworkDetails,
        ({ state, commit }, request) => {
            return axios({
                url: `${state.baseURL}profiles/api/v2/member-profile/save-social-networks`,
                headers: getBasicHeaders(),
                method: 'PUT',
                data: request,
            })
                .then((response) => {
                    commit(storeMutation.setContactInformation, response.data);
                    return response;
                })
                .catch((err) => {
                    console.log(err);
                    throw err;
                });
        },
    ),
    [storeAction.saveExecutiveAssistant]: wrapAction(storeAction.saveExecutiveAssistant, ({ state, commit }, requestBody) => {
        return axios({
            url: `${state.baseURL}profiles/api/v2/member-profile/save-assistant-details`,
            headers: getBasicHeaders(),
            method: 'PUT',
            data: requestBody,
        })
            .then((response) => {
                commit(storeMutation.setContactInformation, response.data);
                return response;
            })
            .catch((err) => {
                console.log(err);
                throw err;
            });
    }),
    [storeAction.getRecommendedEvents]: wrapAction(storeAction.getRecommendedEvents, async ({ state, commit }) => {
        const url = state.recommendedEventsURL;
        const request = {
            url,
            headers: getBasicHeaders(),
            method: 'GET',
        };
        commit(storeMutation.setRecommendedEvents, []);
        return caches.open('MyRecommendedEvents').then((cache) => {
            return cache.match(url).then(async (response) => {
                if (!response) {
                    return fetchAndCacheData(request, commit, storeMutation.setRecommendedEvents, cache, url);
                }
                const responseJSON = await response.json();
                const seconds = 1000 * 60 * 60 * 1;
                if (Date.now() > responseJSON.requestedTime + seconds) {
                    return fetchAndCacheData(request, commit, storeMutation.setRecommendedEvents, cache, url);
                }
                commit(storeMutation.setRecommendedEvents, responseJSON.data);
                return responseJSON.data;
            });
        });
    }),
    [storeAction.getRecommendedMembers]: wrapAction(storeAction.getRecommendedMembers, ({ state, commit }) => {
        const requestSource = getAxiosCancelTokenSource();
            const requestObject = {
                actionName: storeAction.getRecommendedMembers,
                requestSource,
            };
        commit(storeMutation.handleCancelableRequest, requestObject, { root: true });

        return axios({
            url: `${state.baseURL}profiles/api/member-profile/get-recommended-members`,
            headers: getBasicHeaders(),
            method: 'GET',
            cancelToken: requestSource.token,
        })
            .then((response) => {
                commit(storeMutation.setRecommendedMembers, response.data);
                commit(storeMutation.removeCancelableRequest, storeAction.getRecommendedMembers, { root: true });
                return response;
            })
            .catch((err) => {
                console.log(err);
                throw err;
            });
    }),
    [storeAction.disposeRecommendedEvents]: wrapAction(storeAction.Disposition, ({ state }, content) => {
        return axios({
            url: `${state.baseURL}profiles/api/member-profile/save-disposed-events`,
            headers: getBasicHeaders(),
            method: 'POST',
            data: content,
        })
            .then((response) => {
                return response;
            })
            .catch((err) => {
                console.log(err);
                throw err;
            });
    }),
    [storeAction.disposeRecommendedMembers]: wrapAction(storeAction.Disposition, ({ state }, content) => {
        return axios({
            url: `${state.baseURL}profiles/api/member-profile/save-recommended-disposition`,
            headers: getBasicHeaders(),
            method: 'POST',
            data: content,
        })
            .then((response) => {
                return response;
            })
            .catch((err) => {
                console.log(err);
                throw err;
            });
    }),
    [storeAction.getReasonsToConnect]: ({ state, commit }, memberId) => {
        return axios({
            url: `${state.baseURL}profiles/api/member-profile/get-reasons-connect-me/${memberId}`,
            headers: getBasicHeaders(),
            method: 'GET',
        })
            .then((response) => {
                commit(storeMutation.setReasonsToConnect, response.data);
                return response;
            })
            .catch((err) => {
                console.log(err);
                throw err;
            });
    },
    [storeAction.getCommunitiesGroups]: ({ state, commit }, personId) => {
        return axios({
            url: `${state.baseURL}profiles/api/member-profile/get-groups/${personId}`,
            headers: getBasicHeaders(),
            method: 'GET',
        })
            .then((response) => {
                commit(storeMutation.setCommunitiesGroup, response.data);
                return response;
            })
            .catch((err) => {
                console.log(err);
                throw err;
            });
    },
    [storeAction.getAssetSummaryShortcut]: ({ state, commit }, personId) => {
        return axios({
            url: `${state.baseURL}profiles/api/v3/around-me/${personId}/get-myassets-shortcut`,
            headers: getBasicHeaders(),
            method: 'GET',
        })
        .then((response) => {
            commit(storeMutation.setAssetSummaryShortcut, response.data);
            return response;
        })
        .catch((err) => {
            console.log(err);
            throw err;
        });
    },
    [storeAction.getAssetSummary]: wrapAction(storeAction.getAssetSummary, ({ state, commit }, personId) => {
        return axios({
            url: `${state.baseURL}profiles/api/v2/around-me/${personId}/get-myassets`,
            headers: getBasicHeaders(),
            method: 'GET',
        })
        .then((response) => {
            commit(storeMutation.setAssetSummary, response.data);
            return response;
        })
        .catch((err) => {
            console.log(err);
            throw err;
        });
    }),
    [storeAction.addDuplicateAssets]: wrapAction(storeAction.getAssetSummary, ({ state }, content) => {
        return axios({
            url: `${state.baseURL}profiles/api/around-me/add-duplicate-assets`,
            headers: getBasicHeaders(),
            method: 'POST',
            data: content,
        })
        .then((response) => {
            return response;
        })
        .catch((err) => {
            console.log(err);
            throw err;
        });
    }),
    [storeAction.deleteAssets]: wrapAction(storeAction.deleteAssets, ({ state }, content) => {
        return axios({
            url: `${state.baseURL}profiles/api/around-me/delete-assets`,
            headers: getBasicHeaders(),
            method: 'PUT',
            data: content,
        })
        .then((response) => {
            return response;
        })
        .catch((err) => {
            console.log(err);
            throw err;
        });
    }),
    [storeAction.getCountryAndRegions]: ({ state, commit }) => {
        return axios({
            url: `${state.baseURL}profiles/api/around-me/get-countries-and-regions`,
            headers: getBasicHeaders(),
            method: 'GET',
        })
        .then((response) => {
            commit(storeMutation.setCountryAndRegions, response.data);
            return response;
        })
        .catch((err) => {
            console.log(err);
            throw err;
        });
    },
    [storeAction.getChapterAdmin]: ({ state, commit }, personId) => {
        return axios({
            url: `${state.baseURL}profiles/api/member-profile/can-chapter-admin-edit-profile/${personId}`,
            headers: getBasicHeaders(),
            method: 'GET',
        })
            .then((response) => {
                commit(storeMutation.setChapterAdmin, response.data);
                return response;
            })
            .catch((err) => {
                console.log(err);
                throw err;
            });
    },
    [storeAction.getSearchProfile]: wrapAction(storeAction.getSearchProfile, ({ state, commit }, content) => {
        return axios({
            url: `${state.baseURL}profiles/api/around-me/searchprofile`,
            headers: getBasicHeaders(),
            method: 'POST',
            data: content,
        })
        .then((response) => {
            commit(storeMutation.setSearchProfile, response.data);
            return response;
        })
        .catch((err) => {
            console.log(err);
            throw err;
        });
    }),
    [storeAction.updateSubmitAssetDetails]: wrapAction(storeAction.saveAssetDetails, ({ state }, content) => {
        return axios({
            url: `${state.baseURL}profiles/api/around-me/update-and-submit`,
            headers: getBasicHeaders(),
            method: 'PUT',
            data: content,
        })
        .then((response) => {
            return response;
        })
        .catch((err) => {
            return err;
        });
    }),
    [storeAction.saveSubmitAssetDetails]: wrapAction(storeAction.saveAssetDetails, ({ state }, content) => {
        return axios({
            url: `${state.baseURL}profiles/api/around-me/save-and-submit`,
            headers: getBasicHeaders(),
            method: 'POST',
            data: content,
        })
        .then((response) => {
            return response;
        })
        .catch((err) => {
            return err;
        });
    }),
    [storeAction.checkPersonAssetMappingExists]: wrapAction(storeAction.checkPersonAssetMappingExists, ({ state }, content) => {
        return axios({
            url: `${state.baseURL}profiles/api/around-me/is-person-asset-mapping-exists`,
            headers: getBasicHeaders(),
            method: 'POST',
            data: content,
        })
        .then((response) => {
            return response;
        })
        .catch((err) => {
            return err;
        });
    }),
    [storeAction.getStateOrProvinces]: ({ state }, country) => {
        return axios({
            url: `${state.baseURL}profiles/api/around-me/get-states-or-provinces/${country}`,
            headers: getBasicHeaders(),
            method: 'GET',
        })
        .then((response) => {
            return response;
        })
        .catch((err) => {
            console.log(err);
            throw err;
        });
    },
    [storeAction.getPendingAssets]: wrapAction(storeAction.getPendingAssets, ({ state, commit }) => {
        return axios({
            url: `${state.baseURL}profiles/api/around-me/get-pending-assets`,
            headers: getBasicHeaders(),
            method: 'GET',
        })
        .then((response) => {
            commit(storeMutation.setPendingAssets, response.data);
            return response;
        })
        .catch((err) => {
            console.log(err);
            throw err;
        });
    }),
    [storeAction.denyAssetRequest]: wrapAction(storeAction.denyAssetRequest, ({ state }, requestBody) => {
        return axios({
            url: `${state.baseURL}profiles/api/around-me/deny-asset`,
            headers: getBasicHeaders(),
            data: requestBody,
            method: 'PUT',
        })
            .then((response) => {
                return response;
            })
            .catch((err) => {
                console.log(err);
                throw err;
            });
    }),
    [storeAction.approveAssetRequest]: wrapAction(storeAction.approveAssetRequest, ({ state }, requestBody) => {
        return axios({
            url: `${state.baseURL}profiles/api/around-me/approve-asset`,
            headers: getBasicHeaders(),
            data: requestBody,
            method: 'PUT',
        })
            .then((response) => {
                return response;
            })
            .catch((err) => {
                console.log(err);
                throw err;
            });
    }),
    [storeAction.handleLaunchOfMemberProfile]: ({ state, dispatch }, memberData) => {
        const {
            memberId,
            name,
            router,
        } = memberData;

        if (state.currentUserId === memberId) {
            router.push({
                path: '/memberProfile',
                query: {
                    memberId,
                    name,
                    mode: routerNames.EDIT,
                },
            });
        } else {
            dispatch(storeAction.getChapterAdmin, memberId)
                .then(() => {
                    if (state.chapterAdmin) {
                        router.push({
                            path: '/memberProfile',
                            query: {
                                memberId,
                                name,
                                mode: routerNames.EDIT,
                            },
                        });
                    } else {
                        router.push({
                            path: '/memberProfile',
                            query: {
                                memberId,
                                name,
                            },
                        });
                    }
                });
        }
    },
    [storeAction.uploadBulkAddFile]: wrapAction(storeAction.uploadBulkAddFile, ({ state }, formData) => {
        return axios({
            url: `${state.baseURL}profiles/api/around-me/upload-bulk-add-template`,
            headers: getHeadersWithFormData(),
            'Content-Type': 'multipart/form-data',
            method: 'POST',
            data: formData,
        })
            .then((response) => {
                return response;
            })
            .catch((err) => {
                console.log(err);
                throw err;
            });
    }),
    // eslint-disable-next-line no-unused-vars
    [storeAction.downloadBulkAddTemplate]: ({ state }, url) => {
        const commons = axios.defaults.headers.common;
        axios.defaults.headers.common = {};
        return axios.get(url, { responseType: 'blob' })
            .then((response) => {
                const blob = new Blob([response.data]);
                FileSaver.saveAs(blob, 'Businesses-Bulk Add Template.xlsx');
                axios.defaults.headers.common = commons;
                return response;
            })
            .catch((err) => {
                axios.defaults.headers.common = commons;
                console.log(err);
            });
    },
    [storeAction.getEmailExists]: wrapAction(storeAction.getEmailExists, ({ state }, postBody) => {
        return axios({
            url: `${state.baseURL}profiles/api/member-profile/is-email-exists/${postBody.personId}/${postBody.email}`,
            headers: getBasicHeaders(),
            method: 'GET',
        })
        .then((response) => {
            return response;
        })
        .catch((err) => {
            console.log(err);
            throw err;
        });
    }),
    [storeAction.updateAcomplishment]: wrapAction(
        storeAction.updateAcomplishment,
        ({ commit, state }, requestBody) => {
            return axios({
                url: `${state.baseURL}profiles/api/v2/member-profile/update-accomplishment`,
                headers: getBasicHeaders(),
                data: requestBody,
                method: 'PUT',
            })
                .then((response) => {
					commit(storeMutation.setAccomplishments, response.data);
                    return response;
                })
                .catch((err) => {
                    console.log(err);
                    throw err;
                });
        },
    ),
    [storeAction.saveAccomplishments]: wrapAction(
        storeAction.saveAccomplishments,
        ({ commit, state }, requestBody) => {
            return axios({
                url: `${state.baseURL}profiles/api/v2/member-profile/save-accomplishments`,
                headers: getBasicHeaders(),
                data: requestBody,
                method: 'POST',
            })
                .then((response) => {
					commit(storeMutation.setAccomplishments, response.data);
                    return response;
                })
                .catch((err) => {
                    console.log(err);
                    throw err;
                });
        },
    ),
	[storeAction.deleteAccomplishment]: wrapAction(
        storeAction.deleteAccomplishment,
        ({ commit, state }, parms) => {
            return axios({
                url: `${state.baseURL}profiles/api/v2/member-profile/delete-accomplishment/${parms.companyId}`,
                headers: getBasicHeaders(),
                method: 'PUT',
                data: parms,
            })
                .then((response) => {
					commit(storeMutation.setAccomplishments, response.data);
                    return response;
                })
                .catch((err) => {
                    console.log(err);
                    throw err;
                });
        },
    ),
    [storeAction.updateCompanyInvestment]: wrapAction(
        storeAction.updateCompanyInvestment,
        ({ commit, state }, requestBody) => {
            return axios({
                url: `${state.baseURL}profiles/api/v2/member-profile/update-company-investment`,
                headers: getBasicHeaders(),
                data: requestBody,
                method: 'PUT',
            })
                .then((response) => {
					commit(storeMutation.setCompanyInvestments, response.data);
                    return response;
                })
                .catch((err) => {
                    console.log(err);
                    throw err;
                });
        },
    ),
    [storeAction.saveCompanyInvestment]: wrapAction(
        storeAction.saveCompanyInvestment,
        ({ commit, state }, requestBody) => {
            return axios({
                url: `${state.baseURL}profiles/api/v2/member-profile/save-company-investment`,
                headers: getBasicHeaders(),
                data: requestBody,
                method: 'POST',
            })
                .then((response) => {
					commit(storeMutation.setCompanyInvestments, response.data);
                    return response;
                })
                .catch((err) => {
                    console.log(err);
                    throw err;
                });
        },
    ),
	[storeAction.deleteCompanyInvestment]: wrapAction(
        storeAction.deleteCompanyInvestment,
        ({ commit, state }, parms) => {
            return axios({
                url: `${state.baseURL}profiles/api/v2/member-profile/delete-company-investment/${parms.companyId}`,
                headers: getBasicHeaders(),
                method: 'PUT',
                data: parms,
            })
                .then((response) => {
					commit(storeMutation.setCompanyInvestments, response.data);
                    return response;
                })
                .catch((err) => {
                    console.log(err);
                    throw err;
                });
        },
    ),

	[storeAction.updateProfessionalRoles]: wrapAction(
        storeAction.updateProfessionalRoles,
        ({ commit, state }, requestBody) => {
            return axios({
                url: `${state.baseURL}profiles/api/v2/member-profile/update-professional-roles`,
                headers: getBasicHeaders(),
                data: requestBody,
                method: 'PUT',
            })
                .then((response) => {
					commit(storeMutation.setProfessionalRoles, response.data);
                    return response;
                })
                .catch((err) => {
                    console.log(err);
                    throw err;
                });
        },
    ),
    [storeAction.saveProfessionalRoles]: wrapAction(
        storeAction.saveProfessionalRoles,
        ({ commit, state }, requestBody) => {
            return axios({
                url: `${state.baseURL}profiles/api/v2/member-profile/save-professional-roles`,
                headers: getBasicHeaders(),
                data: requestBody,
                method: 'POST',
            })
                .then((response) => {
					commit(storeMutation.setProfessionalRoles, response.data);
                    return response;
                })
                .catch((err) => {
                    console.log(err);
                    throw err;
                });
        },
    ),
	[storeAction.deleteProfessionalRoles]: wrapAction(
        storeAction.deleteProfessionalRoles,
        ({ commit, state }, parms) => {
            return axios({
                url: `${state.baseURL}profiles/api/v2/member-profile/delete-professional-roles/${parms.companyId}`,
                headers: getBasicHeaders(),
                method: 'PUT',
                data: parms,
            })
                .then((response) => {
					commit(storeMutation.setProfessionalRoles, response.data);
                    return response;
                })
                .catch((err) => {
                    console.log(err);
                    throw err;
                });
        },
    ),
    [storeAction.updateTrainingAndCertification]: wrapAction(
        storeAction.updateTrainingAndCertification,
        ({ commit, state }, requestBody) => {
            return axios({
                url: `${state.baseURL}profiles/api/v2/member-profile/update-training-and-certification`,
                headers: getBasicHeaders(),
                data: requestBody,
                method: 'PUT',
            })
                .then((response) => {
					commit(storeMutation.setTrainingAndCertifications, response.data);
                    return response;
                })
                .catch((err) => {
                    console.log(err);
                    throw err;
                });
        },
    ),
    [storeAction.saveTrainingAndCertification]: wrapAction(
        storeAction.saveTrainingAndCertification,
        ({ commit, state }, requestBody) => {
            return axios({
                url: `${state.baseURL}profiles/api/v2/member-profile/save-training-and-certification`,
                headers: getBasicHeaders(),
                data: requestBody,
                method: 'POST',
            })
                .then((response) => {
					commit(storeMutation.setTrainingAndCertifications, response.data);
                    return response;
                })
                .catch((err) => {
                    console.log(err);
                    throw err;
                });
        },
    ),
	[storeAction.deleteTrainingAndCertification]: wrapAction(
        storeAction.deleteTrainingAndCertification,
        ({ commit, state }, parms) => {
            return axios({
                url: `${state.baseURL}profiles/api/v2/member-profile/delete-training-and-certification/${parms.companyId}`,
                headers: getBasicHeaders(),
                method: 'PUT',
                data: parms,
            })
                .then((response) => {
					commit(storeMutation.setTrainingAndCertifications, response.data);
                    return response;
                })
                .catch((err) => {
                    console.log(err);
                    throw err;
                });
        },
    ),
    [storeAction.getProfileDropDowns]: ({ state, commit }) => {
        return axios({
            url: `${state.baseURL}profiles/api/member-profile/get-profile-dropdowns`,
            headers: getBasicHeaders(),
            method: 'GET',
        })
            .then((response) => {
                commit(storeMutation.setProfileDropDowns, response.data);
                return response;
            })
            .catch((err) => {
                console.log(err);
                throw err;
            });
    },
    [storeAction.saveImpersonationRole]: wrapAction(storeAction.saveImpersonationRole, ({ state, commit }, memberId) => {
        const requestBody = {
            personId: memberId || null,
            canImpersonate: !state.canUserImpersonate || false,
        };
        return axios({
            url: `${state.baseURL}profiles/api/member-profile/impersonation`,
            headers: getBasicHeaders(),
            data: requestBody,
            method: 'PUT',
        })
            .then((response) => {
                commit(storeMutation.setImpersonationRole, requestBody.canImpersonate);
                return response;
            })
            .catch((err) => {
                console.log(err);
                throw err;
            });
    }),
};

const memberProfileGetters = {
    [storeGetters.ypoAwardsInformation]: state => state.ypoAwardsInformation,
    [storeGetters.biographyInformation]: state => state.biographyInformation,
    [storeGetters.companyInvestments]: state => state.companyInvestments,
    [storeGetters.championPositions]: state => state.championPositions,
    [storeGetters.familyInterests]: state => state.familyInterests,
    [storeGetters.familyDetails]: state => state.familyDetails,
    [storeGetters.accomplishments]: state => state.accomplishments,
    [storeGetters.professionalRoles]: state => state.professionalRoles,
    [storeGetters.trainingAndCertifications]: state => state.trainingAndCertifications,
    [storeGetters.isAboutMeVisible]: state =>
        state.biographyInformation.length > 0 ||
        state.familyDetails.hasOwnProperty('Child') ||
        state.familyDetails.hasOwnProperty('Spouse/Partner') ||
        state.familyInterests.Personal_Family,
    [storeGetters.isYpoCommunitiesVisible]: state =>
        (state.networkChapters != null && state.networkChapters.length > 0) ||
        (state.networkRegions != null && state.networkRegions.length > 0) ||
        (state.networks != null && state.networks.length > 0),
    [storeGetters.isProfessionalExperienceVisible]: state =>
        state.professionalExperience != null &&
        state.professionalExperience.filter(x => x.isActive === true).length > 0,
    [storeGetters.educationDetails]: state => state.educationDetails,
    [storeGetters.contactInformation]: state => state.contactInformation,
    [storeGetters.emergencyContactRelationTypes]: state => state.emergencyContactRelationTypes,
    [storeGetters.networkChapters]: state => state.networkChapters,
    [storeGetters.networkRegions]: state => state.networkRegions,
    [storeGetters.networks]: state => state.networks,
    [storeGetters.communities]: state => state.communities,
    [storeGetters.events]: state => state.events,
    [storeGetters.myActivity]: state => state.myActivity,
    [storeGetters.currentUserId]: state => state.currentUserId,
    [storeGetters.vCardDetails]: state => state.vCardDetails,
    [storeGetters.professionalExperience]: state => state.professionalExperience,
    [storeGetters.userProfile]: state => state.userProfile,
    [storeGetters.isFormerMember]: state => state.userProfile.isFormerMember,
    [storeGetters.profileConnection]: state => state.profileConnection,
    [storeGetters.profileFollowing]: state => state.profileFollowing,
    [storeGetters.editEducationResponse]: state => state.editEducationResponse,
    [storeGetters.saveEducationResponse]: state => state.saveEducationResponse,
    [storeGetters.schoolTypes]: state => state.schoolTypes,
    [storeGetters.degreeTypes]: state => state.degreeTypes,
    [storeGetters.educationSearchResult]: state => state.educationSearchResult,
    [storeGetters.industory]: state => state.industory,
    [storeGetters.externalConnectionIndustry]: state => state.externalConnectionIndustry,
    [storeGetters.courseAndCertificateSearchResult]: state => state.courseAndCertificateSearchResult,
    [storeGetters.presidentTypes]: state => state.presidentTypes,
    [storeGetters.companyTypes]: state => state.companyTypes,
    [storeGetters.companySizes]: state => state.companySizes,
    [storeGetters.businessScopes]: state => state.businessScopes,
    [storeGetters.countryAndStates]: state => state.countryAndStates,
    [storeGetters.familyInterestTypes]: state => state.familyInterestTypes,
    [storeGetters.businessInterestTypes]: state => state.businessInterestTypes,
    [storeGetters.relationshipStatusTypes]: state => state.relationshipStatusTypes,
    [storeGetters.allPrefixes]: state => state.allPrefixes,
    [storeGetters.allSuffixes]: state => state.allSuffixes,
    [storeGetters.isRelationshipStatus]: state => state.isRelationshipStatus,
    [storeGetters.updatePersonExternalResponse]: state => state.updatePersonExternalResponse,
    [storeGetters.savePersonExternalResponse]: state => state.savePersonExternalResponse,
    [storeGetters.spousePartnerAccessTypes]: state => state.spousePartnerAccessTypes,
    [storeGetters.profilePhoto]: state => state.profilePhoto,
    [storeGetters.professionalExperienceSearchResults]: state => state.professionalExperienceSearchResults,
    [storeGetters.editProfessionalExperienceResponse]: state => state.editProfessionalExperienceResponse,
    [storeGetters.addressTypes]: state => state.addressTypes,
    [storeGetters.socialNetworkTypes]: state => state.socialNetworkTypes,
    [storeGetters.wizards]: state => state.wizards,
    [storeGetters.recommendedEvents]: state => state.recommendedEvents,
    [storeGetters.recommendedMembers]: state => state.recommendedMembers,
    [storeGetters.reasonsToConnect]: state => state.reasonsToConnect,
    [storeGetters.communitiesGroup]: state => state.communitiesGroup,
    [storeGetters.isFamilyInterestsLoading]: state => state.isFamilyInterestsLoading,
    [storeGetters.chapterAdmin]: state => state.chapterAdmin,
    [storeGetters.assetSummaryShortcut]: state => state.assetSummaryShortcut,
    [storeGetters.assetSummary]: state => state.assetSummary,
    [storeGetters.countryAndRegions]: state => state.countryAndRegions,
    [storeGetters.searchProfile]: state => state.searchProfile,
    [storeGetters.pendingAssets]: state => state.pendingAssets,
    [storeGetters.streetAddress]: state => state.streetAddress,
    [storeGetters.profileDropDowns]: state => state.profileDropDowns,
    [storeGetters.userProfileImageExists]: state => state.userProfileImageExists,
    [storeGetters.canUserImpersonate]: state => state.canUserImpersonate,
};

export default {
    namespaced: true,
    state: {
        initialState: memberProfileState,
        ...memberProfileState,
    },
    mutations: { ...memberProfileMutations },
    actions: { ...memberProfileActions },
    getters: { ...memberProfileGetters },
};
